export const PaypalButtonStyle = {
  color: 'silver',
  shape: 'rect',
  label: 'checkout',
};
